import { getSlotImage, Slot, SlotImgDevice } from '@bcraft-frontend-lib/slots'

import { ISlotViewItem } from 'modules/SlotsRoot/types/interfaces/Slots/Slots'

export type SlotIconViewModel = {
  slot: Slot
  gameName: string
  provider: string
  imageUrl: string
  imageUrlWide?: string
}

export const normalizeSlot = (slot: Slot | ISlotViewItem): Slot => {
  if ('externalId' in slot) {
    return slot
  }

  return {
    id: Number(slot.id || slot.gameId),
    name: slot.gameName,
    externalId: slot.gameId,
    integrationName: slot.routeProvider as Slot['integrationName'],
    provider: slot.provider,
  }
}

export const getCatalogImageUrl = (slot: Slot, device: SlotImgDevice = 'desktop'): string =>
  getSlotImage(slot.id, device)

export const adaptSlotForIcon = (
  slot: Slot | ISlotViewItem,
  device: SlotImgDevice = 'desktop',
): SlotIconViewModel => {
  const normalizedSlot = normalizeSlot(slot)

  if ('externalId' in slot) {
    return {
      slot: normalizedSlot,
      gameName: slot.name,
      provider: slot.provider,
      imageUrl: getCatalogImageUrl(normalizedSlot, device),
    }
  }

  return {
    slot: normalizedSlot,
    gameName: slot.gameName,
    provider: slot.provider,
    imageUrl: slot.imageUrl,
    imageUrlWide: slot.imageUrlWide,
  }
}
